import * as rnBlue from './blue.service';

export default angular.module('rhino.core.blue', [

])
  .factory(rnBlue.name, rnBlue.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/blue/blue.module.js